import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Product } from 'src/app/modules/order/models/product';

@Component({
  selector: 'app-shop-products',
  templateUrl: './shop-products.component.html',
  styleUrls: ['./shop-products.component.css']
})
export class ShopProductsComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  products: Product[];

  @Input()
  hideProductName: boolean;

  @Output()
  productClick: EventEmitter<Product> = new EventEmitter<Product>();

  constructor() { }

  ngOnInit(): void {
  }

  onProductClick(product: Product): void {
    this.productClick.emit(product);
  }

}
